import { render, staticRenderFns } from "./CreateSalesNotifications.vue?vue&type=template&id=bfc15124"
import script from "./CreateSalesNotifications.vue?vue&type=script&lang=js"
export * from "./CreateSalesNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports